import videojs from "@/vendor/videojs/video.es.js";

const Plugin = videojs.getPlugin("plugin");

class HiThumbnailGrabber extends Plugin {
  constructor(player, options) {
    super(player, options);
    this.on(player, "getVideoThumbnail", this.getVideoThumbnail);
  }
  getVideoThumbnail(event, cb) {
    let canvas = document.createElement('canvas');
    canvas.height = this.player.hiliteSports.videoEl.videoHeight;
    canvas.width = this.player.hiliteSports.videoEl.videoWidth;
    let ctx = canvas.getContext('2d');
    ctx.drawImage(this.player.hiliteSports.videoEl, 0, 0, canvas.width, canvas.height);
    let thumbnail = canvas.toDataURL();
    if (cb) {
      cb(thumbnail);
    }
  }
}

videojs.registerPlugin("HiThumbnailGrabber", HiThumbnailGrabber);
